import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full gap-6 mx-5 py-5 lg:mx-20 lg:py-10" }
const _hoisted_2 = { class: "flex flex-col gap-6 h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "text-left font-bold text-[16px]" }, "Listado de inversiones", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Agregar nueva inversión", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex justify-between items-center gap-2" }
const _hoisted_7 = { class: "flex lg:flex-row flex-col lg:gap-8 gap-3 lg:items-center items-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Filtrar por:")
], -1)
const _hoisted_9 = { class: "flex flex-row rounded-lg text-button-green items-center justify-start gap-3" }
const _hoisted_10 = { class: "flex flex-row rounded-lg text-button-green items-center justify-start gap-3" }
const _hoisted_11 = { class: "flex flex-row items-center gap-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Agregar nueva inversión", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "text-center"
}

import { onMounted, watch, Ref, ref } from "vue";

import { storeToRefs } from "pinia";

import useInvestmentStore from "@/stores/investment";

import { InvestmentService } from "@/services/invest/investmentService";
//import { Investment } from "@/services/invest/types";

import PaginationControl from "@/components/atoms/PaginationControl.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";
import InvestCard from "@/components/molecules/InvestCard.vue";
import InvestimentModal from "@/components/organisms/InvestimentModal.vue";
import EntitySettingsModal from "@/components/organisms/EntitySettingsModal.vue";
import EntityRecordSettingsModal from "@/components/organisms/EntityRecordSettingsModal.vue";

//const investimentService = new InvestmentService();

export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentsView',
  setup(__props) {

const showModal = ref<boolean>(false);
//const investments: Ref<Investment[]> = ref([]);
const selectedFirstIndex = ref<number>(0);
const selectedSecondIndex = ref<number>(0);

const currentPage: Ref<number> = ref(1);
const totalPages: Ref<number> = ref(0);
const perPage: Ref<number> = ref(0);

const entitySettingsModal = ref<boolean>(false);
const entityRecordSettingsModal = ref<boolean>(false);

function handleAddInvestment() {
  showModal.value = true;
}

/* */
const investmentStore = useInvestmentStore();
const { investments, pagination, filters } = storeToRefs(investmentStore);

function handleFirstSwitchingClick(option: number) {
  if (option == 1) {
    filters.value.type == ""
      ? (filters.value.type = "COMERCIAL")
      : (filters.value.type = "");
  }
  if (option == 2) {
    filters.value.type == ""
      ? (filters.value.type = "HABITACIONAL")
      : (filters.value.type = "");
  }

  pagination.value.page = 1;
  investmentStore.fetchInvestments();
}

function handleSecondSwitchingClick(option: number) {
  if (option == 1) {
    filters.value.status == ""
      ? (filters.value.status = "DISPONIBLE")
      : (filters.value.status = "");
  }
  if (option == 2) {
    filters.value.status == ""
      ? (filters.value.status = "ARRENDADO")
      : (filters.value.status = "");
  }
  if (option == 3) {
    filters.value.status == ""
      ? (filters.value.status = "VENDIDO")
      : (filters.value.status = "");
  }

  pagination.value.page = 1;
  investmentStore.fetchInvestments();
}

const handleSetPage = (page: number) => {
  pagination.value.page = page;
  investmentStore.fetchInvestments();
};

watch(pagination.value, () => {
  investmentStore.fetchInvestments();
});

onMounted(() => {
  investmentStore.fetchInvestments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "flex lg:flex-row flex-col items-start justify-between lg:items-center gap-2" }, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "flex lg:hidden lg:w-[150px] w-[220px] h-full btn",
          onClick: handleAddInvestment
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                _unref(filters).type == 'COMERCIAL'
                  ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                  : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
              ]]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleFirstSwitchingClick(1)), ["stop"]))
            }, " Locales ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                _unref(filters).type == 'HABITACIONAL'
                  ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                  : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
              ]]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleFirstSwitchingClick(2)), ["stop"]))
            }, " Departamentos ", 2)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                _unref(filters).status == 'DISPONIBLE'
                  ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white'
                  : 'border-[#5E9bb441] border-2 text-[#5E9bb441]',
              ]]),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSecondSwitchingClick(1)), ["stop"]))
            }, " Disponibles ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                _unref(filters).status == 'ARRENDADO'
                  ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                  : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
              ]]),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleSecondSwitchingClick(2)), ["stop"]))
            }, " Arrendados ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                _unref(filters).status == 'VENDIDO'
                  ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                  : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
              ]]),
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleSecondSwitchingClick(3)), ["stop"]))
            }, " Vendidos ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Dropdown, { icon: "icon-gear" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "flex flex-row items-center w-full text-nowrap hover:bg-gray-300 rounded-lg transition font-medium",
                onClick: _cache[5] || (_cache[5] = (e) => (entitySettingsModal.value =
              !entitySettingsModal.value))
              }, " Configurar visibilidad de campos ")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "hidden lg:visible lg:flex w-[220px] h-full btn",
            onClick: handleAddInvestment
          }, _hoisted_13)
        ])
      ]),
      _createElementVNode("span", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investments), (item, index) => {
          return (_openBlock(), _createBlock(InvestCard, {
            key: index,
            invest: item
          }, null, 8, ["invest"]))
        }), 128)),
        (_unref(investments) && _unref(investments).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " La búsqueda no obtuvo ningún resultado. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(PaginationControl, {
      selectedPage: _unref(pagination).page,
      perPage: _unref(pagination).per_page,
      totalPages: _unref(pagination).total_pages,
      onSetPage: handleSetPage
    }, null, 8, ["selectedPage", "perPage", "totalPages"]),
    _createVNode(InvestimentModal, {
      visible: showModal.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((showModal).value = $event)),
      type: 0
    }, null, 8, ["visible"]),
    _createVNode(EntitySettingsModal, {
      visible: entitySettingsModal.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((entitySettingsModal).value = $event)),
      onReload: _cache[8] || (_cache[8] = (e) => (entitySettingsModal.value = true))
    }, null, 8, ["visible"]),
    _createVNode(EntityRecordSettingsModal, {
      visible: entityRecordSettingsModal.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((entityRecordSettingsModal).value = $event)),
      onReload: _cache[10] || (_cache[10] = (e) => (entityRecordSettingsModal.value = true))
    }, null, 8, ["visible"])
  ]))
}
}

})